import React from 'react';

const Footer = () => {
    // Inline style for the footer container
    const footerStyle = {
        background: 'rgb(28, 42, 104)',
        color: 'white',
        textAlign: 'center',
        padding: '15px 0',
        position: 'fixed',
        bottom: '0',
        width: '100%',
        marginTop: '20px',
        zIndex: '9999999999999999'
    };

    return (
        <footer style={footerStyle}>
            <div>
                <a style={{ color: 'white', textDecoration: 'none' }} href="https://produits.amphitech.fr/mentions-legales/">Mentions légales</a>  | © 1988-{new Date().getFullYear()} Amphitech. Tous droits réservés.
            </div> 
        </footer>
    ); 
};

export default Footer;